import type { AIProviderName, AIStatus } from '@feedback-system/types';

const PROVIDER_COLORS: Record<AIProviderName, string> = {
  anthropic: 'bg-accent-tan/20 text-accent-tan',
  openai: 'bg-accent-teal/20 text-accent-teal',
  manual: 'bg-accent-primary/20 text-accent-primary',
};

const PROVIDER_LABELS: Record<AIProviderName, string> = {
  anthropic: 'Anthropic',
  openai: 'OpenAI',
  manual: 'Claude (manual)',
};

const STATUS_COLORS: Record<AIStatus, string> = {
  pending: 'bg-dark-200/20 text-dark-200',
  completed: 'bg-accent-green/20 text-accent-green',
  failed: 'bg-accent-red/20 text-accent-red',
  skipped: 'bg-dark-200/20 text-dark-200',
};

interface ProviderBadgeProps {
  provider?: AIProviderName;
  status: AIStatus;
}

export function ProviderBadge({ provider, status }: ProviderBadgeProps) {
  const colors = provider ? PROVIDER_COLORS[provider] : STATUS_COLORS[status];
  const label =
    status === 'pending'
      ? 'Analyzing...'
      : status === 'completed' && provider
        ? PROVIDER_LABELS[provider]
        : status === 'failed'
          ? 'Failed'
          : 'Skipped';

  return <span className={`badge ${colors}`}>{label}</span>;
}
